import { render, staticRenderFns } from "./WeightColumn.vue?vue&type=template&id=d3ec0a3e&"
import script from "./WeightColumn.vue?vue&type=script&lang=js&"
export * from "./WeightColumn.vue?vue&type=script&lang=js&"
import style0 from "./WeightColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3ec0a3e')) {
      api.createRecord('d3ec0a3e', component.options)
    } else {
      api.reload('d3ec0a3e', component.options)
    }
    module.hot.accept("./WeightColumn.vue?vue&type=template&id=d3ec0a3e&", function () {
      api.rerender('d3ec0a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/WeightColumn.vue"
export default component.exports